import React from "react";
import Marquee from "react-fast-marquee";

const items = ["Editing", "Motion Graphics", "Sound Design", "Captions", "Color Grade", "Repurposing", "Short Form", "Brand Films"];

export const Ticker = () => (
  <div className="relative py-10 md:py-14 border-y" style={{ borderColor: "var(--border-color)" }}>
    <Marquee speed={40} gradient gradientColor="#050505" gradientWidth={120}>
      {items.concat(items).map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-heading text-3xl md:text-5xl font-light tracking-tight px-10 md:px-16" style={{ color: "var(--text-secondary)" }}>
            {t}
          </span>
          <span className="h-1.5 w-1.5 rounded-full" style={{ background: "var(--accent-color)" }} />
        </div>
      ))}
    </Marquee>
  </div>
);
